import React from "react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import Modal from "../Modal";
import ImportEffectiveDatesForm from "./ImportEffectiveDatesForm";

const UploadEffectiveDates = (props) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <React.Fragment>
      <Button variant="success" className="ms-2 btn-sm" onClick={() => setModalShow(true)}>
        <i className="fa fa-upload me-1"></i>
        Upload From File
      </Button>
      <Modal
        disableFooter={true}
        show={modalShow}
        title="Update Effective Dates From File"
        modalId="upload_effective_dates_modal"
        modalSize="large"
        body={
          <ImportEffectiveDatesForm
            manufacturers={props.manufacturers}
            manufacturer_networks={props.manufacturer_networks}
            validate_url="/effective_dates/file_validate"
            upload_url="/effective_dates/file_upload"
          />
        }
        dismiss={() => {
          setModalShow(false);
        }}
      />
    </React.Fragment>
  );
};

export default UploadEffectiveDates;
